export const ACCREDITATION_3_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "Value",
    meta_heading: "Human Dignity",
    meta_description: "Every learner matters.",
    meta_priority: 1,
    meta_status: true,
  },

  ACCREDITATION_3_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_primary_color",
      label: "Title primary text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "title_accent_color",
      label: "Title accent text color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E1473F",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "body_text_color",
      label: "Vision / Mission body text color",
      value: "#373737",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#373737",
      required: false,
      defaultValue: "#373737",
    },
    {
      fieldName: "hero_image",
      label: "Hero image (left column)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "hero_image_alt",
      label: "Hero image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "decoration_image",
      label: "Top-left decoration (optional; falls back to built-in rings)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload SVG/PNG",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "decoration_image_alt",
      label: "Decoration alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "vision_title_part_1",
      label: "Vision / title part 1 (primary color)",
      value: "Our ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Our ",
      required: false,
      defaultValue: "Our ",
    },
    {
      fieldName: "vision_title_part_2",
      label: "Vision / title part 2 (accent color)",
      value: "Vision",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Vision",
      required: false,
      defaultValue: "Vision",
    },
    {
      fieldName: "vision_description",
      label: "Vision description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Vision paragraph",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mission_title_part_1",
      label: "Mission / title part 1 (primary color)",
      value: "Our ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Our ",
      required: false,
      defaultValue: "Our ",
    },
    {
      fieldName: "mission_title_part_2",
      label: "Mission / title part 2 (accent color)",
      value: "Mission",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Mission",
      required: false,
      defaultValue: "Mission",
    },
    {
      fieldName: "mission_description",
      label: "Mission description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Mission paragraph",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "values_title_part_1",
      label: "Values section / title part 1 (primary color)",
      value: "Our ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Our ",
      required: false,
      defaultValue: "Our ",
    },
    {
      fieldName: "values_title_part_2",
      label: "Values section / title part 2 (accent color)",
      value: "Values",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Values",
      required: false,
      defaultValue: "Values",
    },
    {
      fieldName: "status",
      label: "Accreditation (Vision / Mission / Values) status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Circle image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload circular image",
    },
    {
      header: "Image alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
    },
    {
      header: "Card title",
      fieldName: "meta_heading",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Human Dignity",
    },
    {
      header: "Card description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Supporting line",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable item",
      defaultValue: true,
    },
  ],
};
